import { useQuery } from '@tanstack/react-query';

import { tenantsApi } from 'src/features/tenants/api';

export function useTenantContextList() {
  const { data: contextList, isLoading } = useQuery({
    queryKey: ['tenantContextList'],
    queryFn: async () => {
      const response = await tenantsApi.getContextList();
      return response.contexts;
    },
    refetchOnWindowFocus: false,
  });

  return {
    contextList: contextList ?? [],
    isLoading,
  };
}
